import { apiClient } from "./api";

export default {
  getPromocodes() {
    return apiClient.post(`/promocode/list`, { action: "list" });
  },
  savePromocode(payload: {
    id?: string;
    code: string;
    discount_percent: number;
    is_active: number;
    all_events: number;
    event_ids: string;
  }) {
    return apiClient.post(`/promocode/save`, payload);
  },
  deletePromocode(payload: { id: string }) {
    return apiClient.post(`/promocode/delete`, payload);
  },
};
